export const BuyerACcountTypes = [
    {name : 'Agent',value:'AGENT'},{name:'AZ',value:'AZ'},{name : 'Importer',value:'IMPORTER'},{name : 'Key Customer',value:'KEY_CUSTOMER'}
]
  

